export default "__VITE_ASSET__DgLBNsEH__"